<template>
  <div id="navigation-drawer"
    v-bind:class="{darkMode: isDarkMode, small: simpleDrawerWidth === 'small', medium: simpleDrawerWidth === 'medium', large: simpleDrawerWidth === 'large'}">
    <div
    @click="openDrawer" class="collapsed-toggle-arow"
    v-bind:class="{collapsed: !collapsedToggleArowVisible}">
      <div class="arrow">
        <img class="chart" src="../../../assets/img/drawer-icon-open-arrow.png" alt="open-arrow">
      </div>
    </div>
    <Drawer align="right" :closeable="false" :mask="false">
      <div v-if="drawerVisible" class="content-container">
        <div @click="closeDrawer" class="arrow-container">
          <div class="arrow">
            <img class="chart" src="../../../assets/img/drawer-icon-close-arrow.png" alt="close-arrow">
          </div>
        </div>
        <div class="content">
          <div class="header-container">
            <navigation-drawer-header
            :totalEvents="totalEvents"
            :totalCustomers="totalCustomers"></navigation-drawer-header>
          </div>
          <div class="body">
            <div class="outages-list-container">
              <outages-list
              :isDarkMode="isDarkMode"
              :selectTab="onSelectTab"
              :selectedTab="selectedTab"
              :restoreData="restoreData"
              :townOutages="townOutages_COPY"
              :countyOutages="countyOutages_COPY"
              :utilityOutages="utilityOutages_COPY"
              :filterTownData="filterTownData"
              :filterCountyData="filterCountyData"
              :filterUtilityData="filterUtilityData"
              :showTownsLayer="showTownsLayer"
              :showCountiesLayer="showCountiesLayer"
              :showUtilitiesLayer="showUtilitiesLayer"></outages-list>
            </div>
          </div>
          <div class="footer-container">
            <navigation-drawer-footer
            :user="user"
            :username="username"
            :userIsAdmin="userIsAdmin"
            :isDarkMode="isDarkMode"
            :toggleDarkMode="toggleDarkMode"
            :showHelpModal="showHelpModal"
            :showLoginModal="showLoginModal"
            :userMenuVisible="userMenuVisible"
            :adminModalVisible="adminModalVisible"
            :onUserAvatarClicked="onUserAvatarClicked"
            :showDataModal="showDataModal"
            :userProfileModalVisible="userProfileModalVisible"
            :dataModalVisible="dataModalVisible"
            :uilityOutagesModalVisible="uilityOutagesModalVisible"
            :forceNewPasswordModalVisible="forceNewPasswordModalVisible"></navigation-drawer-footer>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
import lodash from 'lodash';
import Drawer from "vue-simple-drawer"
import OutagesList from "../../shared/outages-list/OutagesList";
import AppConfig from "../../../resources/AppConfig.js";
import NavigationDrawerHeader from "./NavigationDrawerHeader";
import NavigationDrawerFooter from "./NavigationDrawerFooter";

export default {
  name: 'NavigationDrawer',
  created() {this.createDataCopies()},
  watch: {
    utilityOutages: function () {
      setTimeout(() => {this.createDataCopies()}, 300);
    }
  },
  components: {
    Drawer,
    OutagesList,
    NavigationDrawerHeader,
    NavigationDrawerFooter
  },
  data() {
    return {
      drawerVisible: true,
      townOutages_COPY: [],
      countyOutages_COPY: [],
      utilityOutages_COPY: [],
      collapsedToggleArowVisible: false,
      simpleDrawerWidth: AppConfig.simpleDrawerWidth,
    }
  },
  props: {
    user: Object,
    username: String,
    totalEvents: Number,
    totalCustomers: Number,
    townOutages: Array,
    countyOutages: Array,
    utilityOutages: Array,
    isDarkMode: Boolean,
    selectedTab: String,
    userIsAdmin: Boolean,
    userMenuVisible: Boolean,
    adminModalVisible: Boolean,
    loginModalVisible: Boolean,
    userProfileModalVisible: Boolean,
    uilityOutagesModalVisible: Boolean,
    dataModalVisible: Boolean,
    forceNewPasswordModalVisible: Boolean,
    drawerOpen: Function,
    drawerClosed: Function,
    toggleDarkMode: Function,
    showHelpModal: Function,
    showLoginModal: Function,
    showTownsLayer: Function,
    showCountiesLayer: Function,
    showUtilitiesLayer: Function,
    onUserAvatarClicked: Function,
    forceNewPasswordUser: Function,
    showDataModal: Function,
  },
  methods: {
    copyData(sourceObject) {return JSON.parse(JSON.stringify(sourceObject))},
    closeDrawer() {
      this.drawerVisible = false;
      this.drawerClosed();
      this.restoreData();
      setTimeout(() => this.collapsedToggleArowVisible = true, 300);
      setTimeout(() => document.body.classList.add('navigation-drawer-collapsed'), 300);
    },
    openDrawer() {
      this.drawerVisible = true;
      this.drawerOpen();
      this.collapsedToggleArowVisible = false;
      this.restoreData();
      setTimeout(() => document.body.classList.remove('navigation-drawer-collapsed'), 300);
    },
    onSelectTab(tab) {
      this.restoreData();

      switch(tab) {
        case 'county':
        this.showCountiesLayer();
        break;
        case 'town':
          this.showTownsLayer();
        break;
        case 'utility':
          this.showUtilitiesLayer();
        break;
      }
    },
    createDataCopies() {
      this.utilityOutages_COPY = this.copyData(this.utilityOutages);
      this.townOutages_COPY = this.copyData(this.townOutages);
      this.countyOutages_COPY = this.copyData(this.countyOutages);
      this.$forceUpdate();
    },
    restoreData() {
      this.utilityOutages_COPY = this.copyData(this.utilityOutages);
      this.townOutages_COPY = this.copyData(this.townOutages);
      this.countyOutages_COPY = this.copyData(this.countyOutages);
      this.$forceUpdate();
    },
    emptytData() {
      this.utilityOutages_COPY = [];
      this.townOutages_COPY = [];
      this.countyOutages_COPY = [];
      this.$forceUpdate();
    },
    filterCountyData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      const search = lodash.filter(this.countyOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.countyOutages_COPY = search;
    },
    filterTownData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      const search = lodash.filter(this.townOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.townOutages_COPY = search;
    },
    filterUtilityData(searchString) {
      if (!searchString || !searchString.length) {
        this.restoreData();
        return;
      }

      const search = lodash.filter(this.utilityOutages, outage => {
        return outage.name.toLowerCase().trim().indexOf(searchString) !== -1;
      });

      if (!search || !search.length) {
        this.emptytData();
        return;
      }

      this.utilityOutages_COPY = search;
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

#navigation-drawer{
    &.darkMode{
      .collapsed-toggle-arow{
        background: $whiteTextTrans25;;
      }

      ::v-deep .vue-simple-drawer{
        .content-container{
            .arrow-container {
              background: $whiteTextTrans25;
            }
        }

        .content {
          .footer-container{
            border-top: 1px solid $greyTextTrans65;
          }
        }
      }
    }

  .collapsed-toggle-arow{
    flex: 0 0 10px;
    position: fixed;
    right: 0;
    top: 45%;
    width: 10px;
    height: 40px;
    padding: 10px;
    overflow: auto;
    z-index: 900;
    background: $navyBackgroundTrans50;
    transition: all 0.1s ease;

    &.collapsed{
      right: -50px;
      transition: all 0.5s ease;
    }

    &:hover{
      cursor: pointer;
    }

    .arrow {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: center;
      font-weight: bold;
    }
  }

  ::v-deep .vue-simple-drawer{
      padding: 0;
      background: none;

      .content-container{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;

          .arrow-container {
            flex: 0 0 15px;
            height: 100%;
            padding: 0 0 0 3px;
            background: $navyBackgroundTrans65;

            &:hover{
              cursor: pointer;
            }

            .arrow {
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
            }
          }

          .content {
            flex: 1;
            height: 100%;
            background-color: $navyBackgroundTrans75;
            display:flex;
            flex-direction:column;

            .header-container{
              flex: 1;
              background-color: $navyBackgroundTrans95;
            }

            .body{
              flex: 20;
              position: relative;

              .outages-list-container{
                position: absolute;
                height: 100%;
                width: 100%;
                overflow-y: hidden;
              }
            }

            .footer-container{
              flex: 1 1 35px;
              display: flex;
              align-items: center;
              padding-bottom: 15px;
              background-color: $navyBackgroundTrans95;
            }
          }
      }  
  }
}

#navigation-drawer{
  &.small{
    ::v-deep .vue-simple-drawer{
      width: 425px;
    }
  }
}

#navigation-drawer{
  &.medium{
    ::v-deep .vue-simple-drawer{
      width: 530px;
    }
  }
}

#navigation-drawer{
  &.large{
      ::v-deep .vue-simple-drawer{
      width: 665px;
      }
  }
}
</style>
